import { render, staticRenderFns } from "./QuotaManageComAll.vue?vue&type=template&id=090349a1&scoped=true&"
import script from "./QuotaManageComAll.vue?vue&type=script&lang=js&"
export * from "./QuotaManageComAll.vue?vue&type=script&lang=js&"
import style0 from "./QuotaManageComAll.vue?vue&type=style&index=0&id=090349a1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090349a1",
  null
  
)

export default component.exports